import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '30px'
    }
}));